import { AutomaticCheckJournalFormFields } from 'types';
import { parseDayjsDateIntoString } from '../dateTime/parseDayjsDateIntoString';

export const parseAutomaticCheckJournalFormFieldsIntoAddAutomaticCheckJournalDTO = (
    automaticCheckJournalFormFields: AutomaticCheckJournalFormFields,
) => ({
    from: parseDayjsDateIntoString(automaticCheckJournalFormFields.startDate, 'YYYY-MM-DD'),
    to: parseDayjsDateIntoString(automaticCheckJournalFormFields.finishDate, 'YYYY-MM-DD'),
});
